<template>
	<div class="home-content wrapper">
		<transition name="fadeIn" mode="out-in">
			<div class="home-content__container" v-if="contentData" :key="dataReady">
				<article-view :content-data="contentData"></article-view>

				<footer-comp></footer-comp>
			</div>

			<div v-else class="loading-page" :key="dataReady">
				<loader :label="routeName"></loader>
			</div>
		</transition>
	</div>
</template>

<script>
	import { common } from '~components/common'
	import store from '~store'
	import PageTitleMixin from '~mixins/PageTitle'

	export default {
		name: 'home',
		components: common,
		mixins: [PageTitleMixin],
		created () {
			this.fetchData()
		},
		beforeRouteEnter (to, from, next) {
			store.commit('setRouteLeave', false)
			next()
		},
		beforeRouteLeave (to, from, next) {
			store.commit('setRouteLeave', true)

			setTimeout(() => {
				next()
			}, 1000)
		},
		data () {
			return {
				contentData: null,
				articleLines: null,
				routeName: this.$route.name,
				dataReady: false
			}
		},
		methods: {
			fetchData () {
				this.dispatchPageTitle(wp.site_name)
				this.$store.commit('setPostCategory', null)

				if (!this.$store.getters.getHomeData) {
					this.get('postAll', 'setHomeData', null).then((res) => {
						this.contentData = res
						this.dataReady = 1
					})
				} else {
					const self = this

					setTimeout(() => {
						self.contentData = self.$store.getters.getHomeData
						self.dataReady = 1
					}, 500)
				}
			}
		}
	}
</script>

<style lang="scss">
	.home-content {
		max-width: 80%;

		@include tablet {
			max-width: 90%;
		}
	}

	.home-content__container {
		padding-top: 50px;

		@include mobile {
			padding-top: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/vue/components/content-type/Home.vue?f1344d5c